/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from 'ethers';
import type {
  Signer,
  BigNumberish,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from 'ethers';
import type {NonPayableOverrides} from '../../common';
import type {
  ExchangeContract,
  ExchangeContractInterface,
} from '../../contracts/ExchangeContract';

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'exchange_',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'underlyingToken',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'exchangeComission',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'exchangeLockTime',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'contractValue',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'burnValue',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'buyerAccount',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'payoutAddress_',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'InvalidState',
    type: 'error',
  },
  {
    inputs: [],
    name: 'OnlyBuyer',
    type: 'error',
  },
  {
    inputs: [],
    name: 'OnlySeller',
    type: 'error',
  },
  {
    inputs: [],
    name: '_exchange',
    outputs: [
      {
        internalType: 'address payable',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: '_underlying',
    outputs: [
      {
        internalType: 'contract IERC20',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'balanceOfContract',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'burned',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'buyer',
    outputs: [
      {
        internalType: 'address payable',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'buyerData',
    outputs: [
      {
        internalType: 'bytes',
        name: '',
        type: 'bytes',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'cancelPurchase',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'comission',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    name: 'confirmDelivery',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    name: 'confirmPurchase',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'confirmReceived',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'createdAt',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'deliveryData',
    outputs: [
      {
        internalType: 'bytes',
        name: '',
        type: 'bytes',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'exchange_comission',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'lockTime',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'paySeller',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'payout',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'payoutAddress',
    outputs: [
      {
        internalType: 'address payable',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'percent',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'price',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'buyerRating',
        type: 'uint256',
      },
    ],
    name: 'rateSeller',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'rating',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'shopUpdated',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'state',
    outputs: [
      {
        internalType: 'enum ExchangeContract.State',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'wp',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
] as const;

const _bytecode =
  '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';

type ExchangeContractConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ExchangeContractConstructorParams,
): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class ExchangeContract__factory extends ContractFactory {
  constructor(...args: ExchangeContractConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    exchange_: AddressLike,
    underlyingToken: AddressLike,
    exchangeComission: BigNumberish,
    exchangeLockTime: BigNumberish,
    contractValue: BigNumberish,
    burnValue: BigNumberish,
    buyerAccount: AddressLike,
    payoutAddress_: AddressLike,
    overrides?: NonPayableOverrides & {from?: string},
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      exchange_,
      underlyingToken,
      exchangeComission,
      exchangeLockTime,
      contractValue,
      burnValue,
      buyerAccount,
      payoutAddress_,
      overrides || {},
    );
  }
  override deploy(
    exchange_: AddressLike,
    underlyingToken: AddressLike,
    exchangeComission: BigNumberish,
    exchangeLockTime: BigNumberish,
    contractValue: BigNumberish,
    burnValue: BigNumberish,
    buyerAccount: AddressLike,
    payoutAddress_: AddressLike,
    overrides?: NonPayableOverrides & {from?: string},
  ) {
    return super.deploy(
      exchange_,
      underlyingToken,
      exchangeComission,
      exchangeLockTime,
      contractValue,
      burnValue,
      buyerAccount,
      payoutAddress_,
      overrides || {},
    ) as Promise<
      ExchangeContract & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(
    runner: ContractRunner | null,
  ): ExchangeContract__factory {
    return super.connect(runner) as ExchangeContract__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ExchangeContractInterface {
    return new Interface(_abi) as ExchangeContractInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null,
  ): ExchangeContract {
    return new Contract(
      address,
      _abi,
      runner,
    ) as unknown as ExchangeContract;
  }
}
